import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RCrmListDirty = t.readonly(
  t.type({
    id: t.string,
    name: t.string,
    numResources: t.union([t.number, t.undefined]),
  }),
);

/*
 * Type.
 */

export interface CrmListModel extends t.TypeOf<typeof RCrmListDirty> {}
export const RCrmList = t.clean<CrmListModel>(RCrmListDirty as any);

/*
 * IO methods.
 */

export function parseCrmList(src: any) {
  return {
    id: src.id,
    name: src.name,
    numResources: src.num_resources,
  };
}

/*
 * API type.
 */

export const ApiCrmList = makeApiType('crmList', RCrmList, parseCrmList);
